import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { API, CtnError, CtnHeader, errorText, useCtnMetadata, useCtnRights } from "@/components/ctn/shared";
import { ImportUpload } from "@/components/ctn/import/ImportUpload";
import { ImportReview } from "@/components/ctn/import/ImportReview";
import { ImportHistory } from "@/components/ctn/import/ImportHistory";
import "@/components/ctn/ctn.css";
import "@/components/ctn/import/import.css";
import "@/components/ctn/import/photo-matching.css";

export default function CtnImport() {
  const { manage, purchase, sale } = useCtnRights(), { data: metadata, error: metadataError } = useCtnMetadata();
  const [params, setParams] = useSearchParams(), [error, setError] = useState(""), [history, setHistory] = useState([]);
  const [historyReload, setHistoryReload] = useState(0);
  const jobId = params.get("taak");
  useEffect(() => {
    let active = true, timer;
    const load = async () => {
      try {
        const { data } = await axios.get(`${API}/import`, { timeout: 20000 });
        if (!active) return;
        setHistory(data); setError("");
        if (data.some((job) => ["voorbereiden", "bezig"].includes(job.status))) timer = setTimeout(load, 4000);
      } catch (e) { if (active) setError(errorText(e)); }
    };
    if (manage && !jobId) load();
    return () => { active = false; clearTimeout(timer); };
  }, [manage, jobId, historyReload]);
  if (!manage) return <div className="ctn-module"><CtnError error="Geen rechten om CTN-bestellingen te importeren." /></div>;
  return <div className="ctn-module ctn-import-page" data-testid="ctn-import-page">
    <CtnHeader title="Import" subtitle="Bestellingen en productfoto’s"><Button variant="outline" asChild><Link to="/ctn/overzetten" data-testid="ctn-import-catalog-transfer">Leveranciers & categorieën</Link></Button><Button variant="outline" asChild><Link to="/ctn/export" data-testid="ctn-import-export-link">Back-up / Export</Link></Button></CtnHeader>
    <CtnError error={error || metadataError} />
    {(!purchase || !sale) && <p className="ctn-import-note" data-testid="ctn-import-price-permissions">{!purchase && "Aankoopprijzen worden niet geïmporteerd. "}{!sale && "Verkoopprijzen worden niet geïmporteerd. "}Bestaande afgeschermde prijzen blijven ongewijzigd.</p>}
    <ImportUpload initialKind={params.get("soort")} purchase={purchase} onJob={(job) => { setError(""); setParams({ taak: job.id }); }} onError={setError} />
    {jobId ? <ImportReview key={jobId} jobId={jobId} metadata={metadata} /> : <ImportHistory history={history} onOpen={(id) => setParams({ taak: id })} onRemoved={(id) => { setHistory((old) => old.filter((job) => job.id !== id)); setHistoryReload((value) => value + 1); }} />}
  </div>;
}